import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "@mui/icons-material";

const searchData = [
  { text: "Dashboard", path: "/dashboard" },
  { text: "Partenaires", path: "/partenaires" },
  { text: "Produits", path: "/produits" },
  { text: "Prospects", path: "/prospects" },
  { text: "Calendrier", path: "/calendrier" },
  { text: "Fichiers", path: "/documents" },
  { text: "Documentation", path: "/documentation" },
  { text: "Support", path: "/support" },
];

const Browser = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (value.trim() === "") {
      setSearchResults([]);
      setSearchAnchorEl(null);
      return;
    }

    const results = searchData.filter((item) =>
      item.text.toLowerCase().includes(value.toLowerCase())
    );

    setSearchResults(results);
    setSearchAnchorEl(event.currentTarget);
  };

  const handleSearchSelect = (path) => {
    setSearchTerm("");
    setSearchResults([]);
    setSearchAnchorEl(null);
    navigate(path);
  };

  const handleSearchEnter = (event) => {
    if (event.key === "Enter" && searchResults.length > 0) {
      handleSearchSelect(searchResults[0].path);
    }
  };

  return (
    <div className="relative w-56 z-0">
      <div className="flex items-center bg-gray-100 border border-gray-300 rounded-md px-3 py-1.5 transition-all focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-300">
        <input
          type="text"
          placeholder="Rechercher..."
          className="w-full bg-transparent focus:outline-none text-sm text-gray-700 placeholder-gray-400"
          value={searchTerm}
          onChange={handleSearchChange}
          onKeyDown={handleSearchEnter}
        />
        <Search className="text-gray-400" style={{ fontSize: 20 }} />
      </div>
      {searchResults.length > 0 && (
        <ul className="absolute bg-white shadow-md rounded-md mt-2 w-full z-20 text-sm text-gray-800 border border-gray-200">
          {searchResults.map((item, index) => (
            <li
              key={index}
              className="px-3 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleSearchSelect(item.path)}
            >
              {item.text}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Browser;
